// extracted by mini-css-extract-plugin
export default {"container":"R4-z","list":"S4-z"};